(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yu-faq-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yu-faq-category')) {
    customElements.define('yu-faq-category', class extends HTMLElement {
      connectedCallback() {
        this._controller?.abort();
        this._controller = new AbortController();
        const { signal } = this._controller;
        const answerSelector = '.yu-faq-category__questions accordion-custom > details';
        const closeOtherAnswers = current => {
          document.querySelectorAll('yu-faq-category ' + answerSelector + '[open]').forEach(answer => {
            if (answer !== current) answer.open = false;
          });
        };
        this.addEventListener('click', event => {
          if (event.defaultPrevented || !(event.target instanceof Element)) return;
          const answer = event.target.closest('summary')?.parentElement;
          if (answer?.matches(answerSelector) && !answer.open) closeOtherAnswers(answer);
        }, { signal });
        this.addEventListener('toggle', event => {
          const answer = event.target;
          if (answer instanceof HTMLDetailsElement && answer.matches(answerSelector) && answer.open) {
            closeOtherAnswers(answer);
          }
        }, { capture: true, signal });
        if (!window.Shopify?.designMode) return;
        const reveal = event => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          const category = this.querySelector(':scope > details');
          if (category) category.open = true;
        };
        document.addEventListener('shopify:block:select', reveal, { signal: this._controller.signal });
      }
      disconnectedCallback() { this._controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yu-home-sanctuary"] && !Shopify.designMode) return;
  try {
    

  (() => {
    'use strict';
    const tag = 'yu-sanctuary-banner';
    if (customElements.get(tag)) return;

    class YuSanctuaryBanner extends HTMLElement {
      connectedCallback() {
        if (this.initialise()) return;
        this.childObserver = new MutationObserver(() => {
          if (this.initialise()) this.childObserver.disconnect();
        });
        this.childObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.ready = false;
        this.childObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      initialise() {
        if (this.ready) return true;
        this.stage = this.querySelector('.yu-home-sanctuary__stage');
        this.media = this.querySelector('.yu-home-sanctuary__media');
        this.content = this.querySelector('.yu-home-sanctuary__content');
        this.image = this.querySelector('.yu-home-sanctuary__image');
        this.caption = this.querySelector('.yu-home-sanctuary__side-caption');
        if (!this.stage || !this.media || !this.content || !this.querySelector('.yu-home-sanctuary__actions')) return false;

        if (this.stage.classList.contains('yu-home-sanctuary__stage--caption') && !this.caption) return false;
        this.ready = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const schedule = () => this.schedule();
        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(schedule);
          [this, this.media, this.content].forEach(node => this.resizeObserver.observe(node));
        }
        window.addEventListener('resize', schedule, options);
        window.addEventListener('pageshow', schedule, options);
        this.image?.addEventListener('load', schedule, options);
        this.image?.addEventListener('error', () => {
          this.dataset.layout = 'stacked';
        }, options);
        document.fonts?.ready.then(() => { if (this.isConnected && this.ready) this.schedule(); });
        this.schedule();
        return true;
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected && this.ready) this.measure();
        });
      }

      measure() {
        const width = this.stage.getBoundingClientRect().width;
        const settings = getComputedStyle(this);
        const photographHeight = this.image?.getBoundingClientRect().height || 0;
        const stackedY = parseFloat(settings.getPropertyValue('--yu-sanctuary-copy-mobile-y')) || 0;
        this.style.setProperty('--yu-sanctuary-stacked-y', Math.max(stackedY, -Math.max(0, photographHeight - 24)) + 'px');
        if (!this.image || width < 1100 || window.innerWidth < 1100 || (this.image.complete && !this.image.naturalWidth)) {
          this.dataset.layout = 'stacked';
          return;
        }
        // Probe synchronously. The image alone determines the banner height.
        this.dataset.layout = 'overlay';
        const photograph = this.image.getBoundingClientRect();
        const content = this.content.getBoundingClientRect();
        const inset = 32;
        let rightEdge = width - inset;
        if (this.caption && getComputedStyle(this.caption).display !== 'none') {
          rightEdge = Math.min(rightEdge, this.caption.getBoundingClientRect().left - photograph.left - 20);
        }
        if (content.height > photograph.height - 12 || content.width < 280 ||
            this.content.scrollWidth > this.content.clientWidth + 1 || rightEdge - inset < content.width) {
          this.dataset.layout = 'stacked';
          return;
        }
        const requestedX = (parseFloat(settings.getPropertyValue('--yu-sanctuary-copy-start')) || 0) / 100;
        const parsedY = parseFloat(settings.getPropertyValue('--yu-sanctuary-copy-y'));
        const requestedY = Number.isFinite(parsedY) ? parsedY / 100 : .5;
        const x = Math.min(Math.max(inset, width * requestedX), rightEdge - content.width);
        const y = Math.min(Math.max(0, photograph.height * requestedY - content.height / 2), photograph.height - content.height);
        this.style.setProperty('--yu-sanctuary-placed-x', x + 'px');
        this.style.setProperty('--yu-sanctuary-placed-y', y + 'px');
      }

    }
    customElements.define(tag, YuSanctuaryBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yu-six-image-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yu-preparation-progress')) {
    customElements.define('yu-preparation-progress', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.connectProgress();
        });
      }

      connectProgress() {
        this.track = this.closest('.yu-six-strip')?.querySelector('.yu-six-strip__track');
        this.rail = this.querySelector('.yu-six-strip__progress-rail');
        this.thumb = this.querySelector('.yu-six-strip__progress-thumb');
        if (!this.track || !this.rail || !this.thumb) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateProgress();
          });
        };
        this.track.addEventListener('scroll', this.queueUpdate, { passive: true });
        this.mobile.addEventListener('change', this.queueUpdate);
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this.track);
        this.resizeObserver.observe(this.rail);
        this.queueUpdate();
      }

      updateProgress() {
        const visibleWidth = this.track.clientWidth;
        const totalWidth = this.track.scrollWidth;
        const overflow = totalWidth - visibleWidth;
        this.hidden = !this.mobile.matches || visibleWidth === 0 || overflow <= 1;
        if (this.hidden) return;
        const railWidth = this.rail.clientWidth;
        const thumbWidth = railWidth * visibleWidth / totalWidth;
        const progress = Math.max(0, Math.min(1, this.track.scrollLeft / overflow));
        this.thumb.style.width = `${thumbWidth}px`;
        this.thumb.style.transform = `translateX(${(railWidth - thumbWidth) * progress}px)`;
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.track?.removeEventListener('scroll', this.queueUpdate);
        this.mobile?.removeEventListener('change', this.queueUpdate);
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
